module.exports = __webpack_public_path__ + "static/media/logoBaloto.acd6ebfa.png";